<div class="card h-100 card-no-border mt-4">
    <div class="card-body no-padding">
        <cfg-table [resource]="customersResource" [rows]="rows()" [columns]="columns()" [trackBy]="trackById"
            [searchFields]="['customerId', 'name']" searchParam="search" searchStorageKey="customers" searchPlaceholder="Søg kunder..." [defaultSort]="{ key: 'customerId', direction: 'desc' }"
            [rowLink]="rowLink" [rowLabel]="rowLabel" (searchEnter)="fastAction($event)"
            emptyText="Ingen kunder at vise." loadingText="Indlæser kunder"
            errorText="Fejl under indlæsning af kunder.">

            <ng-template cfgCell="status" [cfgCellOf]="rows()" let-row>
                @if (row.provisioning; as p) {
                    @if (p.state === 'failed') {
                        <button class="btn btn-sm btn-outline-danger" (click)="finishSetup(row.customerId)"
                            [disabled]="p.completing"
                            [title]="p.errorMessage || 'Provisionering fejlede'">
                            @if (p.completing) {
                                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                            }
                            Prøv igen
                        </button>
                    } @else if (p.state === 'ready') {
                        <button class="btn btn-sm btn-success" (click)="finishSetup(row.customerId)"
                            [disabled]="p.completing">
                            @if (p.completing) {
                                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                            }
                            Fuldfør opsætning
                        </button>
                    } @else {
                        <button class="btn btn-sm btn-secondary" disabled="true">
                            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                            Opretter…
                        </button>
                    }
                } @else if (!row.hasDatabase) {
                    <span class="text-muted" title="Kunden har ingen database i dette miljø og kan ikke åbnes">
                        <i class="fa-solid fa-triangle-exclamation text-warning me-1" aria-hidden="true"></i>
                        Ingen database
                    </span>
                }
            </ng-template>
        </cfg-table>
    </div>
</div>
